// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__185tV","label":"styles_label__1bDYu"};